import { NotificationPayloadT } from 'lib-shared-legacy-types';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { change } from 'redux-form';

import { withRouter } from 'hocs/router';

import { notificationActions } from '../../../components/notifications/actions/notification';
import { withTags } from '../../../hocs';
import {
  FORM_NAME,
  TagsCreateModalDispatchProps,
  TagsCreateModalForm,
  TagsCreateModalOwnProps,
  TagsCreateModalStateProps,
} from '../components/tagsCreateModal';

const mapDispatchToProps = (
  dispatch: Dispatch,
): TagsCreateModalDispatchProps => ({
  notificationAdd: (payload: NotificationPayloadT) =>
    dispatch(notificationActions.notificationAdd(payload)),
  changeFieldValue: function (field: string, value: any) {
    dispatch(change(FORM_NAME, field, value));
  },
});

const TagsCreateModal = withTags(TagsCreateModalForm);

export default withRouter(
  connect<
    TagsCreateModalStateProps,
    TagsCreateModalDispatchProps,
    TagsCreateModalOwnProps,
    {}
  >(
    undefined,
    mapDispatchToProps,
  )(TagsCreateModal),
);
